import type { State } from './serviceProviderQuickResidentSelectionReducer';
import type { ResidentType } from './ReceiptServiceProviderBatchQuickResidentSelectionForm';
import type { LineItem } from '../ServiceProviderReceiptBatchForm';

export const selectLeftArrowDisabled = (state: State): boolean => {
  return state.filteredStagedForDeselection.length === 0;
};

export const selectRightArrowDisabled = (state: State): boolean => {
  return state.staged.length === 0;
};

export const selectNonSelected = (state: State): ResidentType[] =>
  state.nonSelected;

export const selectStaged = (state: State): ResidentType[] => state.staged;

export const selectFilteredStagedForDeselection = (
  state: State
): ResidentType[] => state.filteredStagedForDeselection;

export const selectFilteredNonSelected = (state: State): ResidentType[] =>
  state.filteredNonSelected;

export const selectFilteredSelected = (state: State): ResidentType[] =>
  state.filteredSelected;

export const selectLineItems = (state: State): LineItem[] => state.lineItems;
